var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTradetrust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29043_83551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5939 2.50839V2.5H3.53387L1 6.42052V6.44553H14.0568L16.5939 2.50839Z",
    fill: "#3A8CC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7494 11.6816V7.35547H6.84448V17.742L10.7494 11.6816Z",
    fill: "#3A8CC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1379 16.4394V12.1133H13.2328V22.4997L17.1379 16.4394Z",
    fill: "#F57A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 7.25781H13.7556L11.2214 11.1782V11.2037H20.4703L23 7.25781Z",
    fill: "#F57A29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29043_83551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradetrust);
export default __webpack_public_path__ + "static/media/tradetrust.5a955148b6b7a6451bd3c83792995fe6.svg";
export { ForwardRef as ReactComponent };